module.exports = __webpack_public_path__ + "static/pizza23-8a6cffed2ec99fb9cc520d0d9a0d2d46.webp";